<template>
  <p class="customp" v-markdown="text" v-show="!currentConstituency || !currentConstituency.name"/>
</template>

<script>
import {mapState} from 'vuex'
import {store} from './store-constituency'

export default {
  props: ['attributes'],
  computed: {
    ...mapState(['variableData']),
    text: function () {
      return this.$replaceVar(this.attributes.value).replace('is zero event', 'are no events').replace('zero event', 'no events')
    },
    currentConstituency () {
      return store.currentConstituency
    }
  },
  watch: {
    currentConstituency: function (neVal) {
      if (neVal.name) {
        this.$el.closest('.component.component-customp').classList.add('none')
      } else {
        this.$el.closest('.component.component-customp').classList.remove('none')
      }
    }
  }
}
</script>

<style lang="scss">
</style>
